import React from 'react'
import react_code from "./reactjs_code.jpg"
import ich from "./neu ich.png"
import grieche2 from "./grieche 2.png"
import unternehmensgruppe from "./papa_webseite.png"
import "./headline.css"
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPython, faJs, faHtml5, faCss3, faJava, faReact, faBootstrap, faGithub } from '@fortawesome/free-brands-svg-icons'

import { faC, faCode } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used

import fitness from "./fitness.png"
import wetterapp from "./wetterapp.png"
import four_connect from "./four_connect.png"
import four from "./four.png"
import responsive_design from "./responsive_design.png"
import netflix from "./netflix.png"
import todo from "./todo.png"

const myStyle = {
    display: "flex",
    justifyContent: "center",
}
const myBackground = {
    height: "auto",
    width: "100%"
}
const home = () => {
    return (
        <div style={{overflowX:"hidden"}}>
            <About_Me_Text_2/>
            <Skills_2/>
            <Projekte_Webseite_2/>
            <Portfolio_Footer/>
        </div>
    )
}

const container_style = {
    border: "2px solid grey",
    borderRadius:"10px", 
    backgroundColor:"ivory"
}

function About_Me_Text(){
    return(
        <div>
            <div className='container' >
                <div className='row'>
                <h2 style={{color:"white"}}>Adrian Dröse</h2>
                    <div className="col-sm-7" style={container_style}>
                        <p>
                        Ich bin ein <strong>Frontend Developer</strong> und lebe derzeit in Neuruppin. Während meines <strong>Informatikstudiums</strong> habe ich mich bereits für die Entwicklung von Webseiten und auch den damit verbundenen <strong>Web-Applikationen</strong> begeistert. Im Laufe meines Studiums habe ich mir die Fertigkeiten eines Frontend-Developers angeeignet und auch bereits <strong>Projekte für Kunden</strong> umgesetzt.
                        Neben der Arbeit mit Programmierkenntnissen aus dem Frontend-Bereich habe ich mir auch weitere <strong>Programmiersprachen</strong> beigebracht, die für das Studium notwendig waren.
                        </p>
                        <p>
                            Für die Umsetzung von Ideen in Code bin ich zuständig, aber auch für die Lösung von Problemen mittels meiner erworbenen Fähigkeiten. Ebenso bin ich für die Beratung sowie für Ideenvorschläge für Sie da.
                        </p>
                        <p>
                            Außerhalb meines Studiums bin ich seit mehr als 2 Jahren <strong>Fußballtrainer einer F-Junioren Mannschaft</strong>. In diesem Zeitraum habe ich eine Trainerlizenz <strong>(DOSB-Lizenz)</strong> erworben und meine <strong>kommunikativen</strong> sowie <strong>zwischenmenschlichen Fähigkeiten</strong> stark verfeinert. Außerdem wurde mit der Planung von Trainingseinheiten, Spielen und Ausflügen meine <strong>Verantwortung, Selbstständigkeit sowie Aufgabenbereitschaft</strong> geprüft, aber auch vorangebracht. Durch die damit verbundenen Aufgaben ist die Kommunikation mit anderen für mich kein Problem.
                        </p>
                        <p>
                            Sollte ich bei Ihnen das Interesse geweckt haben, dann haben Sie keine Scheu und kontaktieren mich. Haben Sie weiteres Interesse an meinen technischen Fähigkeiten, dann scollen Sie einfach weiter.
                        </p>
                    </div>
                    
                    <div className='col-sm-5'>
                        <img src={ich}/>
                    </div>
                </div>
            </div>
        </div>
    )
}



function About_Me_Text_2(){
    return(
        <div>
            <div className='container' >
                <div className='row'>
                <h2 id='myHeader'>Adrian Dröse Frontend Developer</h2>
                <hr style={{color:"lightgrey"}}/>
                    <div className="col-sm-7"  style={{color:"darkgrey"}}>
                        <p>
                        Ich bin ein <strong>Frontend Developer</strong> und lebe derzeit in Neuruppin. Während meines <strong>Informatikstudiums (Bachelor of Science)</strong> habe ich mich bereits für die Entwicklung von Webseiten und auch den damit verbundenen <strong>Web-Applikationen</strong> begeistert. Im Laufe meines Studiums habe ich mir die Fertigkeiten eines Frontend-Developers angeeignet und auch bereits <strong>Projekte für Kunden</strong> umgesetzt.
                        Neben der Arbeit mit Programmierkenntnissen aus dem Frontend-Bereich habe ich mir auch weitere <strong>Programmiersprachen</strong> beigebracht, die für das Studium notwendig waren.
                        </p>
                        <p>
                            Für die Umsetzung von Ideen in Code bin ich zuständig, aber auch für die Lösung von Problemen mittels meiner erworbenen Fähigkeiten. Ebenso bin ich für die Beratung sowie für Ideenvorschläge für Sie da.
                        </p>
                        <p>
                            Außerhalb meines Studiums bin ich seit mehr als 2 Jahren <strong>Fußballtrainer einer F-Junioren Mannschaft</strong>. In diesem Zeitraum habe ich eine Trainerlizenz <strong>(DOSB-Lizenz)</strong> erworben und meine <strong>kommunikativen</strong> sowie <strong>zwischenmenschlichen Fähigkeiten</strong> stark verfeinert. Außerdem wurde mit der Planung von Trainingseinheiten, Spielen und Ausflügen meine <strong>Verantwortung, Selbstständigkeit sowie Aufgabenbereitschaft</strong> geprüft, aber auch vorangebracht. Durch die damit verbundenen Aufgaben ist die Kommunikation mit anderen für mich kein Problem.
                        </p>
                        <p>
                            Sollte ich bei Ihnen das Interesse geweckt haben, dann haben Sie keine Scheu und kontaktieren mich. Haben Sie weiteres Interesse an meinen technischen Fähigkeiten, dann scollen Sie einfach weiter.
                        </p>
                    </div>
                    
                    <div className='col-sm-5'>
                        <img src={ich}/>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            
        </div>
    )
}


function Skills_2(){
    return(
        <div>
            <div className='container' style={{color:"darkgrey"}}>
                    <div className='row'>
                            <h3>Skills</h3>
                            <div className='col-sm-6'>
                                <p>
                                Meine vorrangigen Fähigkeiten liegen in der Fronend Entwicklung-
                                </p>
                                <p>
                                    <strong>Programmiersprachen sowie verwendete Bibliotheken und weiteres Wissen:</strong>
                                </p>
                                <p><strong>Frontend: </strong>HTML5, CSS3, JavaScript(ES6), Bootstrap, React.js, Responsive Design</p>
                                <p><strong>Programmiersprachen: </strong>Python (Beautiful Soup, Requests, PDFMiner, Elasticsearch, Pygame, NLTK), C/C#, Java, SQL</p>
                                <p><strong>Werkzeuge: </strong>Elastcisearch, Git, Github, Chrome DevTools, GithubPages</p>
                                <p><strong>Weiteres Wissen: </strong> MS PowerPoint, MS Word</p>
                                <div>
                                <FontAwesomeIcon style={{height:"40px"}} icon={faPython} />
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faJs}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faHtml5}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faCss3}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faReact}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faJava}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faBootstrap}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faGithub}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faC}/>
                                <FontAwesomeIcon style={{height:"40px", marginLeft:"10px"}} icon={faCode}/>
                                </div>
                            </div>
                            <div className='col-sm-6'>
                                <img class="rounded float-start img-fluid" src={react_code}/>
                            </div>
                    </div>
                    <hr style={{color:"lightgrey"}}/>
            </div>
        </div>
    )
}

function Projekte_Webseite_2(){
    return(
        <div>
            <div class="container">
                <h2 style={{color:"white"}}>Projekte</h2>
                <p style={{color:"lightgrey"}}>Im Folgenden sind meine bisherigen Projekte aufgelistet, die meine Fähigkeiten und mein erworbenes Wissen als Frontend Developer reflektieren sollen. Wenn Sie zu einem Projekt genauere Informationen möchten, klicken Sie auf das jeweilige Bild.</p>
                <div class="row">
                    <div class="col-sm-6">
                        <a href="https://businesswebsites.github.io/griechisches-restaurant-atos.github.io/index.html">
                        <img style={container_style} class="rounded float-start img-fluid" src={grieche2}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Griechisches Restaurant Atos Neuruppin</h2>
                        <p>Das griechische Restaurant Atos in Neuruppin hat mich angefragt, ob ich ihre eigene Webseite erstellen könnte. Gemeinsam haben wir, ihre Ideen, Vorstellungen und Wünsche umgesetzt, sodass die Webseite von den meisten Geräten problemlos besucht werden kann. Das Design war den Kunden dabei besonders wichtig, da der griechische Stil auf jeden Fall zur Geltung kommen sollte.</p>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                    <h2 >Unternehmensgruppe Dröse Neuruppin</h2>
                        <p>Diese Webseite habe ich für meinen Vater, meinen Onkel und mich aufgesetzt, um damit für die Kunden in der Umgebung online auffindbar zu sein. Das Design der Webseite wurde den Wünschen meines Vaters entsprechend entworfen. Die Seite sollte schlicht sein, aber auch trotzdem mittels ausgewählter Bilder die Fähigkeiten verdeutlichen.</p>  
                    </div>
                    <div class="col-sm-6">
                        <img style={container_style} class="rounded float-start img-fluid" src={unternehmensgruppe}/>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6" >
                        <img style={container_style} class="rounded float-start img-fluid" src={fitness}/>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Fitness Lifestyle Web-Applikation (noch im Aufbau)</h2>
                        <p>Die Idee eines Bekannten habe ich begonnen mittels meiner Fähigkeiten aus dem Frontend Bereich umzusetzen. Wir haben uns zunächst zusammengesetzt und seine Idee konzeptioniert. Anschließend haben wir uns Meilensteinen für die Erstellung dieses Projektes gesetzt und treffen uns regelmäßig, um die Fortschritte zu besprechen sowie neue Meilensteine zu setzen. Das Projekt umfasst hierbei eine Web-Applikation, die für den Fitness & Ernährungslifestyle gedacht ist.  </p>  
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Wetter Web Applikation (Verwendung API)</h2>
                        <p>Bei dieser Wetter Applikation habe ich den Umgang mit einer API geübt und gelernt. Die Daten wurden mit der API von <a href='https://openweathermap.org/'>https://openweathermap.org/</a> eingeholt und anschließend genutzt, um sie in der App darzustellen. </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='https://businesswebsites.github.io/weatherapp.github.io/index.html'>
                        <img style={container_style} class="rounded float-start img-fluid" src={wetterapp}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-sm-6" >
                        <a href='https://businesswebsites.github.io/four_connect.github.io/'><img style={container_style} class="rounded float-start img-fluid" src={four}/></a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Kleine Spiele (Beispiel: 4 gewinnt)</h2>
                        <p>Um meine Kenntnisse mit den Frontend Werkzeugen zu verbessern, habe ich kleine simple Spiele programmiert und entweder bei Github gehostet oder auch einfach den Code mancher Spiele/Anwendungen hochgeladen. Für weitere Informationen geht es hier zu meinem Github Account: <a href='https://github.com/businesswebsites'>https://github.com/businesswebsites</a>. </p>  
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >Responsive Web Design (Virtual Keyboard)</h2>
                        <p>Um meine Fähigkeiten im Responsive Web Design darzustellen, ist meine Portfolio Webseite ein Beispiel. Aber ich habe auch bei weiteren Projekten Responsive Design angewandt. Zum Beispiel die abgebildete Keyboard Anwendung.   </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='https://businesswebsites.github.io/keyboard.github.io/'>
                        <img style={container_style} class="rounded float-start img-fluid" src={responsive_design}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                <div class="col-sm-6" >
                        <a href='https://businesswebsites.github.io/netflix_clone.github.io/'>
                        <img style={container_style} class="rounded float-start img-fluid" src={netflix}/>
                        </a>
                    </div>
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >NETFLIX Clone Webseite (noch im Aufbau)</h2>
                        <p>Als ein größeres Projekt habe ich begonnen, die Netflix Webseite nachzubilden. Bei diesem Projekt sollen einerseits meine Skills im Design trainiert werden und andererseits auch die Umsetzung verschiedener Fertigkeiten im Bereich der Frontend-Entwicklung. Bisher ist die Seite nur für den Computergebrauch gestaltet. Es stehen für die dargestellten Bilder auch Kurzfilme zur Verfügung, die abgespielt werden, sobald der Nutzer die Mouse über eines der Bilder bewegt. Um den bisherigen Stand der Webseite zu überprüfen, klicken Sie einfach auf das Bild und Sie werden zur Seite weitergeleitet.  </p>  
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-6" style={{color:"darkgrey"}}>
                        <h2 >CRUD (Create-Read-Update-Delete) Beispiel: To-Do-Liste</h2>
                        <p>  Am Beispiel einer To-Do-Liste habe ich meine Fertigkeiten mit CRUD geübt und gelernt. Es ist ein simples, aber auch hilfreiches Projekt, da durch die Einfachheit das Konzept von CRUD deutlich verständlicher wurde und somit auch einfach zu erlernen war. </p>  
                    </div>
                    <div class="col-sm-6" >
                        <a href='https://businesswebsites.github.io/to_do.github.io/'>
                        <img style={container_style} class="rounded float-start img-fluid" src={todo}/>
                        </a>
                    </div>
                </div>
                <hr style={{color:"lightgrey"}}/>
            </div>

        </div>
    )
}

function Portfolio_Footer(){
    return(
        <MDBFooter bgColor='dark' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>

        Melden Sie sich bei mir, wenn Ihnen mein Portfolio gefällt.
        
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-2" />
                Portfolio Adrian Dröse
              </h6>
              <p>
                Kontaktieren Sie mich unter der angegebenen E-Mail oder per Telefon. Besuchen Sie bei Interesse außerdem meine Github-Seite, wo Sie Programme finden können, die ich im Laufe meines Studiums geschrieben habe.
              </p>
              
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Kontakt</h6>
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                droese.websites@gmail.com
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-2" />
                adrian.droese@web.de
              </p>
              <p>
                {/*<MDBIcon icon="github" className="me-2" /> https://github.com/businesswebsites*/}
                <a className="me-2 text-reset fw-bold" href='https://github.com/businesswebsites' >Github</a>
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2022 Copyright: 
        <a className='text-reset fw-bold' href='https://businesswebsites.github.io/portfolio/'>
        https://businesswebsites.github.io/portfolio/
        </a>
      </div>
    </MDBFooter>
    )
}


export default home